import { render, staticRenderFns } from "./PhoneCom.vue?vue&type=template&id=798761c8&scoped=true"
import script from "./PhoneCom.vue?vue&type=script&lang=js"
export * from "./PhoneCom.vue?vue&type=script&lang=js"
import style0 from "./PhoneCom.vue?vue&type=style&index=0&id=798761c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798761c8",
  null
  
)

export default component.exports